export const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID
export const REACT_APP_SECRET = process.env.REACT_APP_SECRET
export const REACT_APP_RAPIDAPI_KEY = process.env.REACT_APP_RAPIDAPI_KEY